import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { read, utils } from "xlsx";

const ImportResidentImportExcel = ({ setCsvData }) => {
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        // Do whatever you want with the file contents
        const ab = reader.result;
        const wb = read(ab, { type: "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = utils.sheet_to_json(ws, {
          header: 1,
          defval: "",
          raw: false,
        });

        setCsvData(data);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: ".csv",
  });

  return (
    <React.Fragment>
      <div className="card">
        <div className="card-header">Import clients</div>
        <div className="card-block">
          <p>
            One Step allows you to import clients by uploading a CSV file that
            you will then map to fields in client profile
          </p>
          <div
            style={{
              borderStyle: "dashed",
              width: "40%",
              marginTop: 10,
              height: "400px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <div>Drag 'n' drop the CSV, or click to select CSV</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ImportResidentImportExcel;
